module.exports = __webpack_public_path__ + "static/media/empty-bids.9b5bc95d.svg";